import { useModelService } from "@shared/services/api/hooks/useModelService";
import { useMemo } from "react";
import PublicVenueRatingsRepository from "../repositories/PublicVenueRatingsRepository";

const usePublicVenueRatingsService = (venueId: number) => {
  const repository = useMemo(
    () => new PublicVenueRatingsRepository({ venueId }),
    [venueId]
  );

  const modelService = useModelService(repository);

  return {
    ...modelService,
  };
};

export default usePublicVenueRatingsService;
